import api from '../../../api';

export const workflowStepList = workflowId => api.get('WorkflowStep/List', {
  params: { workflowId },
}).then(response => response.data.return);

export const createWokFlowStep = params => api.post('WorkflowStep/CreateWokFlowStep/', {
  RequestWrapper: {
    WorkFlowId: params.WorkFlowId,
    LstStep: params.Steps,
  },
}).then(response => response.data);



// WEBPACK FOOTER //
// ./src/redux/actions/tracker/workflowstepActions.js